import { Injectable } from '@angular/core';
import { GraphQLError } from 'graphql';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(
    private messageService: MessageService
  ) { }

  showSuccess(detail: string, summary: string = "Sucesso") {
    this.messageService.add({
      severity: 'success',
      summary: summary,
      detail: detail
    });
  }

  showError(detail: string, summary: string = "Erro") {
    if (detail.includes('401') || detail.includes('403')) {
      this.messageService.add({
        severity: 'error',
        summary: summary,
        detail: "Sessão expirada. Por favor, realize o login novamente."
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: summary,
        detail: detail
      });
    }
  }

  showWarn(detail: string, summary: string = "Atenção") {
    this.messageService.add({
      severity: 'warn',
      summary: summary,
      detail: detail
    });
  }

  showInfo(detail: string, summary: string = "Atenção") {
    this.messageService.add({
      severity: 'info',
      summary: summary,
      detail: detail
    });
  }

  showGQLError(err: any, summary: string = "Erro") {
    if (err.message.includes('401') || err.message.includes('403')) {
      this.messageService.add({
        severity: 'error',
        summary: summary,
        detail: "Sessão expirada. Por favor, realize o login novamente."
      })
    } else {
      this.messageService.add({
        severity: 'error',
        summary: summary,
        detail: err.message
      });
    }
  }
}
